(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-section"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var iframe = document.querySelector('.iframe-section__embed iframe');

  function adjustIframeHeight() {
    if (iframe) {
      var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
      if (iframeDocument) {
        var iframeHeight = iframeDocument.body.scrollHeight;
        iframe.style.height = iframeHeight + 'px';
        
        var iframeSection = document.querySelector('.iframe-section');
        if (iframeSection) {
          iframeSection.style.height = iframeHeight + 'px';
        }
      }
    }
  }

  // Adjust height on load
  iframe.onload = adjustIframeHeight;

  // Adjust height on window resize
  window.addEventListener('resize', adjustIframeHeight);
});

  } catch(e) { console.error(e); }
})();
})();
